import { Button, Flex } from '@chakra-ui/react';
import { TitleBar } from '@resistapp/client/components/bars/title-bar';
import { theme } from '@resistapp/client/components/shared/theme';
import { NavLink } from 'react-router-dom';
import { AllUsersSection } from '../organisations-view/users-section';

export function AdminUsersView() {
  return (
    <div style={{ marginBottom: theme.spacing[16] }}>
      <TitleBar
        title="Users"
        $extraWide={true}
        controls={
          <Flex gap={theme.spacing[4]}>
            <Button as={NavLink} to="/user" alignSelf="center">
              New user
            </Button>
          </Flex>
        }
      />
      <AllUsersSection />
    </div>
  );
}
